import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MSG_SUCCESS, MSG_SUCCESS_DEL} from '../enums/constants';
import {IUser} from '../models/IUser';
import {ICurUserRights} from '../models/ICurUserRights';

@Injectable({
    providedIn: 'root',
})
export class GfxStoreService {
    // Constants
    private readonly INIT_TITLE = 'Accueil';

    // Behavior Subjects
    private initUser: IUser;
    curUser: IUser;
    private user = new BehaviorSubject<IUser | null>(null);
    private mdl = new BehaviorSubject({id: '', itemName: ''});
    private title = new BehaviorSubject<string>(this.INIT_TITLE);
    private menus = new BehaviorSubject<any[]>([]);

    loggedIn;
    // Public Observables
    currentUser = this.user.asObservable();
    currentMdl = this.mdl.asObservable();
    currentTitle = this.title.asObservable();
    currentMenus = this.menus.asObservable();


    // Event Emitters
    public profilChangeEvent = new EventEmitter<any>();


    private _cur_profil_choix: any = {
        profil: null,
        domain: null
    };

    private _central_msg_success = MSG_SUCCESS;
    private _central_msg_success_del = MSG_SUCCESS_DEL;
    private _onGoingPostOrPut = false;

    constructor() {
        this.intializeMdl();
        this.intializeUser();
        this.intializeTitle();
        this.intializeProfChoix();
        this.initializeFromSessionStorage();
    }

    private initializeFromSessionStorage(): void {
        const storageItems = [
            {key: 'user', action: (val: any) => this.changeUser(val)},
            {key: 'menus', action: (val: any) => this.changeMenus(val)},
            {key: 'module', action: (val: any) => this.changeModule(val)},
            {key: 'title', action: (val: any) => this.changeCurrTitle(val)},

        ];

        storageItems.forEach(item => {
            const storedValue = sessionStorage.getItem(item.key);
            if (storedValue && storedValue !== 'undefined') {
                try {
                    item.action(JSON.parse(storedValue));
                    if (item.key === 'user') {
                    }
                } catch (e) {
                    console.error(`Error parsing ${item.key} from session storage`, e);
                }
            }
        });
    }

    // Initialization Methods
    intializeProfChoix() {
        this._cur_profil_choix = {
            role: null,
            domain: null
        };
    }

    removeCurChoixProf() {
        this.intializeProfChoix();
    }

    intializeMdl() {
        this.mdl = new BehaviorSubject({id: '', itemName: ''});
        this.currentMdl = this.mdl.asObservable();
    }

    intializeUser() {
        this.user = new BehaviorSubject(this.initUser);
        this.currentUser = this.user.asObservable();
    }

    intializeTitle() {
        this.title = new BehaviorSubject(this.INIT_TITLE);
        this.currentTitle = this.title.asObservable();
    }

    // Public Methods


    changeUser(user: IUser): void {
        this.curUser = user;
        this.user.next(user);
    }

    changeMenus(menus: any[]): void {
        this.menus.next(menus);
    }


    changeModule(mdl: any): void {
        this.mdl.next(mdl);
    }

    changeCurrTitle(title: string): void {
        this.title.next(title);
    }


    // Getters for current values
    getCurrUser(): IUser | null {
        return this.user.getValue();
    }

    getCurrMenus(): any[] {
        return this.menus.getValue();
    }


    get cur_profil_choix(): any {
        return this._cur_profil_choix;
    }

    set cur_profil_choix(value: any) {
        this._cur_profil_choix = value;
    }

    get central_msg_success(): string {
        return this._central_msg_success;
    }

    set central_msg_success(value: string) {
        this._central_msg_success = value;
    }

    get central_msg_success_del(): string {
        return this._central_msg_success_del;
    }

    set central_msg_success_del(value: string) {
        this._central_msg_success_del = value;
    }


    get onGoingPostOrPut(): boolean {
        return this._onGoingPostOrPut;
    }

    set onGoingPostOrPut(value: boolean) {
        this._onGoingPostOrPut = value;
    }


}
